import { render, staticRenderFns } from "./ProHighlights.vue?vue&type=template&id=57d9e823&scoped=true&"
import script from "./ProHighlights.vue?vue&type=script&lang=js&"
export * from "./ProHighlights.vue?vue&type=script&lang=js&"
import style0 from "./ProHighlights.vue?vue&type=style&index=0&id=57d9e823&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d9e823",
  null
  
)

export default component.exports